import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventspageService } from '../../eventspage.service';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-event-article-re-events',
  templateUrl: './event-article-re-events.component.html',
  styleUrls: ['./event-article-re-events.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class EventArticleReEventsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() pageData: any;
  queryParams: any;
  constructor(private route: ActivatedRoute) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  eventDetailData: any;

  ngOnInit(): void {}
  ngOnChanges(): void {
    let data = this?.pageData?.fields;
    if (data != null) {
      this.eventDetailData = {
        header: data?.subpanelTitle || '',
        relatedEvents: data?.relatedEvents || [],
      };
    }
  }
}
